import { reviewLockNotice } from "../utils/credentialLock";

/**
 * Tells the professional why a credential's reviewed fields are read-only.
 * Renders nothing when the credential can be edited in full. With
 * `onRequestChange` (a verified credential, nothing waiting) it offers to
 * send a change to the verifier instead.
 */
export function ReviewLockNotice({ status, onRequestChange }) {
  const notice = reviewLockNotice(status);
  if (!notice) return null;
  return (
    <div
      role="note"
      className="p-3.5 rounded-lg bg-slate-50 border border-slate-200 text-xs font-medium text-slate-700"
    >
      {notice}
      {onRequestChange && (
        <>
          {" "}
          To correct the verified details, send a change to your verifier (the
          verification fee applies).{" "}
          <button
            type="button"
            onClick={onRequestChange}
            className="font-semibold text-[var(--color-primary)] underline bg-transparent border-0 p-0 cursor-pointer"
          >
            Request a change
          </button>
        </>
      )}
    </div>
  );
}

/** The notice while a change of a verified credential is being proposed. */
export function ProposeChangeNotice({ onCancel }) {
  return (
    <div
      role="note"
      className="p-3.5 rounded-lg bg-amber-50 border border-amber-200 text-xs font-medium text-amber-900"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          Change what needs correcting. The verifier who verified this
          credential checks the change, for the verification fee. Until they
          approve, your profile shows the verified details.
        </div>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="text-amber-800 hover:text-amber-950 font-semibold underline shrink-0 cursor-pointer text-xs bg-transparent border-0 p-0"
          >
            Cancel change
          </button>
        )}
      </div>
    </div>
  );
}
